module.exports = __webpack_public_path__ + "img/scroll.98f6bbca.svg";